// @flow

import { RestClientAuthenticated } from '../network';
import { turanBaseURL } from '../../utils/urlUtils';

const retailerApi = {
  fetchCrossSellByRetailerId: (retailerId: number, limit: number, sameBl1) =>
    new RestClientAuthenticated(`${turanBaseURL()}/retailers/${retailerId}/cross-sell`, 'GET')
      .addParam('limit', limit)
      .addParam('sameBl1', sameBl1)
      .execute(),
  fetchAttractiveScoreByRetailerId: (retailerId: number) =>
    new RestClientAuthenticated(`${turanBaseURL()}/retailers/${retailerId}/attractivescore`, 'GET')
      .execute(),
};

export default retailerApi;
